/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 23/08/22
 */

import LoadWorkplanProvider from '@/components/contexts/WorkplanContext/providers/LoadWorkplanProvider';
import React, { ReactNode, useMemo } from 'react';

const WorkplanCurrentYearProvider = ({ children }: { children?: ReactNode }) => {
    const getPath = useMemo(() => () => `workplan/current`, []);
    return (
        <LoadWorkplanProvider getPath={getPath} method="GET">
            {children}
        </LoadWorkplanProvider>
    );
};

export default WorkplanCurrentYearProvider;
